
const IS_LOCAL = false;
export const Baseurl = IS_LOCAL ? "http://localhost:3000/admin/api" : 'https://api.stockpatti.com/admin/api';